import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import LocalText from '../components/common/LocalText';
import ContentArea from '../components/content-area/Content';
import AdvertiserCampaignList from '../components/advertisers/AdvertiserCampaignList';
import { getAdvertiserById } from '../api/advertiserApi';
import { useLocalization } from '../context/LocalizationContext';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';

const AdvertiserBrandPage = () => {
  const { brandId } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { locale } = useLocalization();
  const [brand, setBrand]       = useState(state?.advertiser ?? null);
  const [loading, setLoading]   = useState(!state?.advertiser);
  const overrideSpaceId = state?.overrideSpaceId ?? null;

  useEffect(() => {
    if (state?.advertiser) return;
    setLoading(true);
    getAdvertiserById(Number(brandId), overrideSpaceId)
      .then(setBrand)
      .catch(() => setBrand(null))
      .finally(() => setLoading(false));
  }, [brandId, state?.advertiser, overrideSpaceId]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
        <CircularProgress sx={{ color: '#0a326d' }} />
      </Box>
    );
  }

  if (!brand) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="40vh" gap={2}>
        <Typography variant="h6" sx={{ color: '#85a5c6' }}><LocalText>Advertiser not found.</LocalText></Typography>
        <Button variant="outlined" onClick={() => navigate('/advertisers')} sx={{ textTransform: 'none', borderRadius: '10px', color: '#0a326d', borderColor: '#0a326d' }}>
          <LocalText>Back to Advertisers</LocalText>
        </Button>
      </Box>
    );
  }

  return (
    <ContentArea
      title={brand.localizedName?.values?.find((v) => v.localeId === locale)?.value || brand.localizedName?.values?.[0]?.value || 'Campaigns'}
      icon={<CampaignOutlinedIcon sx={{ fontSize: { xs: 20, sm: 24, md: 28 } }} />}
      container={false}
    >
      <AdvertiserCampaignList
        advertiser={brand}
        overrideSpaceId={overrideSpaceId}
        onSelectCampaign={(campaign) =>
          navigate(`/advertisers/${brandId}/campaign/${campaign.id}`, { state: { campaign, advertiser: brand, overrideSpaceId } })
        }
      />
    </ContentArea>
  );
};

export default AdvertiserBrandPage;
